/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-explicit-any */
// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// third-party
import { useTranslation } from 'react-i18next';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item, showDivider }: any) => {
	const theme: any = useTheme();
	const { t } = useTranslation();

	// menu list collapse & items
	const items = item.children?.map((menu: any) => {
		switch (menu.type) {
			case 'collapse':
				return <NavCollapse key={menu.id} menu={menu} level={1} />;
			case 'item':
				return <NavItem key={menu.id} item={menu} level={1} />;
			default:
				return (
					<Typography key={menu.id} variant='h6' color='error' align='center'>
						Menu Items Error
					</Typography>
				);
		}
	});

	return (
		<>
			{showDivider && <Divider sx={{ mb: 1.25 }} />}

			<List
				subheader={
					item.title && (
						<Typography
							variant='caption'
							sx={{ ...theme.typography.menuCaption }}
							display='block'
							gutterBottom
						>
							{t(item.title)}
							{item.caption && (
								<Typography
									variant='caption'
									sx={{ ...theme.typography.subMenuCaption }}
									display='block'
									gutterBottom
								>
									{item.caption}
								</Typography>
							)}
						</Typography>
					)
				}
			>
				{items}
			</List>
		</>
	);
};

export default NavGroup;
